import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleProduct = (id) => {
  return useQuery({
    queryKey: ["product", id],
    queryFn: async () => {
      const res = await api.get(`/product/${id}`);
      return res.data;
    },
    enabled: !!id, // prevents unnecessary call
  });
};